
// import React, { useState, useCallback } from 'react';
// import { useQuery, useMutation, gql } from '@apollo/client';
// import { debounce } from 'lodash';
// import { FaEdit, FaSave, FaTimes } from 'react-icons/fa';

// const GET_ALL_EVENTS = gql`
//   query GetAllEvents {
//     getAllEvents {
//       eventorder_generated_id
//       customer_generated_id
//       ordered_at
//       delivery_status
//       paymentid
//       delivery_details
//       event_order_details
//       payment_status
//       event_order_status
//       total_amount
//     }
//   }
// `;

// const UPDATE_EVENT_ORDER_STATUS = gql`
//   mutation UpdateEventOrderStatus($id: ID!, $status: String!) {
//     updateEventOrderStatus(id: $id, status: $status) {
//       eventorder_generated_id
//       event_order_status
//     }
//   }
// `;

// const EventOrderList = () => {
//   const [searchTerms, setSearchTerms] = useState({
//     eventorder_generated_id: '',
//     customer_id: '',
//     ordered_at: '',
//     delivery_status: '',
//     paymentid: '',
//     delivery_details: '',
//     event_order_details: '',
//     payment_status: '',
//     event_order_status: '',
//     total_amount: '',
//   });
//   const [editingOrderId, setEditingOrderId] = useState(null);
//   const [editingValues, setEditingValues] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [ordersPerPage] = useState(10);
//   const [saveError, setSaveError] = useState(null);

//   const { loading, error, data } = useQuery(GET_ALL_EVENTS);
//   const [updateEventOrderStatus] = useMutation(UPDATE_EVENT_ORDER_STATUS);

//   const filteredOrders = data ? data.getAllEvents.filter(order => {
//     return Object.entries(searchTerms).every(([key, value]) => {
//       if (!value) return true;
//       return order[key]?.toString().toLowerCase().includes(value.toLowerCase());
//     });
//   }) : [];

//   const debouncedSearch = useCallback(
//     debounce((searchTerms) => {
//       setSearchTerms(searchTerms);
//       setCurrentPage(1);
//     }, 300),
//     []
//   );

//   const handleSearchChange = (e) => {
//     const { name, value } = e.target;
//     debouncedSearch({ ...searchTerms, [name]: value });
//   };

//   const handleEdit = (orderId, order) => {
//     setEditingOrderId(orderId);
//     setEditingValues({ ...order });
//     setSaveError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditingValues(prev => ({ ...prev, [name]: value }));
//     setSaveError(null);
//   };

//   const handleSave = async (orderId) => {
//     try {
//       setSaveError(null);

//       if (!editingValues.event_order_status) {
//         throw new Error('Order status is required');
//       }

//       await updateEventOrderStatus({
//         variables: {
//           id: orderId,
//           status: editingValues.event_order_status
//         },
//         update: (cache) => {
//           const { getAllEvents } = cache.readQuery({ query: GET_ALL_EVENTS });
//           const updatedOrders = getAllEvents.map(order => 
//             order.eventorder_generated_id === orderId 
//               ? { ...order, event_order_status: editingValues.event_order_status }
//               : order
//           );
//           cache.writeQuery({
//             query: GET_ALL_EVENTS,
//             data: { getAllEvents: updatedOrders },
//           });
//         },
//       });

//       setEditingOrderId(null);
//       setEditingValues({});
//     } catch (error) {
//       console.error('Error updating order:', error);
//       setSaveError(error.message);
//     }
//   };

//   const handleDiscard = () => {
//     setEditingOrderId(null);
//     setEditingValues({});
//     setSaveError(null);
//   };

//   const headers = [
//     { key: 'eventorder_generated_id', label: 'ID' },
//     { key: 'customer_generated_id', label: 'Cust.ID' },
//     { key: 'ordered_at', label: 'Date' },
//     { key: 'delivery_status', label: 'Del.Status' },
//     { key: 'delivery_details', label: 'Del.Details' },
//     { key: 'paymentid', label: 'Pay.ID' },
//     { key: 'event_order_details', label: 'Order Details' },
//     { key: 'payment_status', label: 'Pay.Status' },
//     { key: 'event_order_status', label: 'Order Status' },
//     { key: 'total_amount', label: 'Amount' },
//     { key: 'actions', label: 'Actions' }
//   ];

//   const indexOfLastOrder = currentPage * ordersPerPage;
//   const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   if (loading) return <div className="text-center">Loading...</div>;
//   if (error) return <div className="text-center text-red-500">Error: {error.message}</div>;

//   return (
//     <div className="container mx-auto p-4">
//       <h1 className="text-2xl font-bold mb-4">Event Order List</h1>
//       {saveError && (
//         <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
//           <p>{saveError}</p>
//         </div>
//       )}
//       <div className="overflow-x-auto">
//         <table className="min-w-full bg-white">
//           <thead>
//             <tr>
//               {headers.map(header => (
//                 <th key={header.key} className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   {header.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             <tr>
//               {headers.map(header => (
//                 <td key={header.key} className="px-4 py-2">
//                   {header.key !== 'actions' && (
//                     <input
//                       type="text"
//                       name={header.key}
//                       placeholder={`Search ${header.label}`}
//                       value={searchTerms[header.key]}
//                       onChange={handleSearchChange}
//                       className="w-full p-1 border rounded text-sm"
//                     />
//                   )}
//                 </td>
//               ))}
//             </tr>
//             {currentOrders.map((order) => (
//               <tr key={order.eventorder_generated_id}>
//                 {headers.map(header => (
//                   <td key={header.key} className="px-4 py-2 text-sm">
//                     {editingOrderId === order.eventorder_generated_id && header.key === 'event_order_status' ? (
//                       <input
//                         type="text"
//                         name="event_order_status"
//                         value={editingValues.event_order_status || ''}
//                         onChange={handleInputChange}
//                         className="w-full p-1 border rounded text-sm"
//                       />
//                     ) : header.key === 'actions' ? (
//                       <div className="flex space-x-2">
//                         {editingOrderId === order.eventorder_generated_id ? (
//                           <>
//                             <button onClick={() => handleSave(order.eventorder_generated_id)} className="text-green-600 hover:text-green-900">
//                               <FaSave />
//                             </button>
//                             <button onClick={handleDiscard} className="text-gray-600 hover:text-gray-900">
//                               <FaTimes />
//                             </button>
//                           </>
//                         ) : (
//                           <button onClick={() => handleEdit(order.eventorder_generated_id, order)} className="text-blue-600 hover:text-blue-900">
//                             <FaEdit />
//                           </button>
//                         )}
//                       </div>
//                     ) : (
//                       <div className="whitespace-pre-wrap">{JSON.stringify(order[header.key], null, 2)}</div>
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="mt-4 flex justify-between items-center">
//         <p className="text-sm text-gray-700">
//           Showing {indexOfFirstOrder + 1} to {Math.min(indexOfLastOrder, filteredOrders.length)} of {filteredOrders.length} results
//         </p>
//         <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
//           {[...Array(Math.ceil(filteredOrders.length / ordersPerPage))].map((_, index) => (
//             <button
//               key={index}
//               onClick={() => paginate(index + 1)}
//               className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
//                 currentPage === index + 1
//                   ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600'
//                   : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
//               }`}
//             >
//               {index + 1}
//             </button>
//           ))}
//         </nav>
//       </div>
//     </div>
//   );
// };

// export default EventOrderList;







import React, { useState, useCallback } from 'react';
import { useQuery, useMutation, gql } from '@apollo/client';
import { debounce } from 'lodash';
import { FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import OrderItemsDisplay from './components/OrderItemsDisplay';
import AddressDisplay from './components/AddressDisplay';
import StatusBadge from './components/StatusBadge';

const GET_ALL_EVENTS = gql`
  query GetAllEvents {
    getAllEvents {
      order_generated_id
      customer_generated_id
      delivery_status
      paymentid
      order_details
      customer_address
      payment_status
      total_amount
    }
  }
`;

const UPDATE_EVENT_ORDER_STATUS = gql`
  mutation UpdateEventOrderStatus($id: ID!, $status: String!) {
    updateEventOrderStatus(id: $id, status: $status) {
      order_generated_id
      delivery_status
    }
  }
`;

const EventOrderList = () => {
  const [searchTerms, setSearchTerms] = useState({
    order_generated_id: '',
    customer_id: '',

    delivery_status: '',
    paymentid: '',

    order_details: '',
    customer_address: '',
    payment_status: '',

    total_amount: '',
  });
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editingValues, setEditingValues] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [saveError, setSaveError] = useState(null);

  const { loading, error, data } = useQuery(GET_ALL_EVENTS);
  const [updateEventOrderStatus] = useMutation(UPDATE_EVENT_ORDER_STATUS);

  const filteredOrders = data ? data.getAllEvents.filter(order => {
    return Object.entries(searchTerms).every(([key, value]) => {
      if (!value) return true;
      return order[key]?.toString().toLowerCase().includes(value.toLowerCase());
    });
  }) : [];

  const debouncedSearch = useCallback(
    debounce((searchTerms) => {
      setSearchTerms(searchTerms);
      setCurrentPage(1);
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    debouncedSearch({ ...searchTerms, [name]: value });
  };

  const handleEdit = (orderId, order) => {
    setEditingOrderId(orderId);
    setEditingValues({
      delivery_status: order.delivery_status || ''
    });
    setSaveError(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingValues(prev => ({ ...prev, [name]: value }));
    setSaveError(null);
  };

  const handleSave = async (orderId) => {
    try {
      setSaveError(null);

      if (!editingValues.delivery_status) {
        throw new Error('status is required');
      }

      await updateEventOrderStatus({
        variables: {
          id: orderId,
          status: editingValues.delivery_status
        },
        update: (cache) => {
          const { getAllEvents } = cache.readQuery({ query: GET_ALL_EVENTS });
          const updatedOrders = getAllEvents.map(order =>
            order.order_generated_id === orderId
              ? { ...order, delivery_status: editingValues.delivery_status }
              : order
          );
          cache.writeQuery({
            query: GET_ALL_EVENTS,
            data: { getAllEvents: updatedOrders },
          });
        },
      });

      setEditingOrderId(null);
      setEditingValues({});
    } catch (error) {
      console.error('Error updating order:', error);
      setSaveError(error.message);
    }
  };

  const handleDiscard = () => {
    setEditingOrderId(null);
    setEditingValues({});
    setSaveError(null);
  };

  const headers = [
    { key: 'order_generated_id', label: 'ID' },
    { key: 'customer_generated_id', label: 'Cust.ID' },
    // { key: 'ordered_at', label: 'Date' },
    { key: 'delivery_status', label: 'Del.Status' },
    // { key: 'delivery_details', label: 'Del.Details' },
    { key: 'paymentid', label: 'Pay.ID' },
    { key: 'order_details', label: 'Order Details' },
    { key: 'customer_address', label: 'address' },
    { key: 'payment_status', label: 'Pay.Status' },

    { key: 'total_amount', label: 'Amount' },
    { key: 'actions', label: 'Actions' }
  ];

  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <div className="text-center">Loading...</div>;
  if (error) return <div className="text-center text-red-500">Error: {error.message}</div>;

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4"> Orders List</h1>
      {saveError && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
          <p>{saveError}</p>
        </div>
      )}
      <div className="overflow-x-auto shadow-lg rounded-lg border border-gray-200">
        <table className="min-w-full bg-white divide-y divide-gray-200">
          <thead>
            <tr>
              {headers.map(header => (
                <th key={header.key} className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {header.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            <tr>
              {headers.map(header => (
                <td key={header.key} className="px-4 py-2">
                  {header.key !== 'actions' && (
                    <input
                      type="text"
                      name={header.key}
                      placeholder={`Search ${header.label}`}
                      value={searchTerms[header.key]}
                      onChange={handleSearchChange}
                      className="w-full p-1 border rounded text-sm"
                    />
                  )}
                </td>
              ))}
            </tr>
            {currentOrders.map((order) => (
              <tr key={order.order_generated_id}>
                {headers.map(header => (
                  <td key={header.key} className="px-4 py-3 text-sm align-top">
                    {editingOrderId === order.order_generated_id && header.key === 'delivery_status' ? (
                      <input
                        type="text"
                        name="delivery_status"
                        value={editingValues.delivery_status || ''}
                        onChange={handleInputChange}
                        placeholder="Enter status"
                        className="w-full px-2 py-1 text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    ) : header.key === 'actions' ? (
                      <div className="flex space-x-2">
                        {editingOrderId === order.order_generated_id ? (
                          <>
                            <button
                              onClick={() => handleSave(order.order_generated_id)}
                              className="text-green-600 hover:text-green-900 p-1"
                              title="Save changes"
                            >
                              <FaSave />
                            </button>
                            <button
                              onClick={handleDiscard}
                              className="text-gray-600 hover:text-gray-900 p-1"
                              title="Cancel"
                            >
                              <FaTimes />
                            </button>
                          </>
                        ) : (
                          <button
                            onClick={() => handleEdit(order.order_generated_id, order)}
                            className="text-blue-600 hover:text-blue-900 p-1"
                            title="Edit status"
                          >
                            <FaEdit />
                          </button>
                        )}
                      </div>
                    ) : header.key === 'order_details' ? (
                      <OrderItemsDisplay orderDetails={order.order_details} />
                    ) : header.key === 'customer_address' ? (
                      <AddressDisplay address={order.customer_address} />
                    ) : header.key === 'delivery_status' ? (
                      <StatusBadge status={order.delivery_status} />
                    ) : header.key === 'payment_status' ? (
                      <StatusBadge status={order.payment_status} />
                    ) : header.key === 'total_amount' ? (
                      <span className="font-semibold text-gray-900">₹{order.total_amount?.toFixed(2)}</span>
                    ) : (
                      <span className="text-gray-700">{order[header.key]}</span>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-4 flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">

            <div>
              <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                {[...Array(Math.ceil(filteredOrders.length / ordersPerPage))].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => paginate(index + 1)}
                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${currentPage === index + 1
                      ? 'z-10 bg-indigo-600 text-white'
                      : 'text-gray-900 ring-1 ring-inset ring-gray-300'
                      }`}
                  >
                    {index + 1}
                  </button>
                ))}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventOrderList;
